import { CFormInput } from '@coreui/react-pro'
import { useField } from 'formik'
import cn from 'classnames'
import { FormInvalidFeedback } from './FormInvalidFeedback'

export const FormTextInput = ({ className, type, id, placeholder, name, disabled }) => {
  const [field, meta] = useField({ type, id, placeholder, name })

  const isValid = !!(meta.touched && meta.error)
  const feedbackMsg = isValid ? meta.error : ''

  return (
    <div className={cn('my-3', className)}>
      <CFormInput
        floatingLabel={placeholder}
        type={type}
        disabled={disabled}
        id={id}
        placeholder={placeholder}
        name={name}
        {...field}
        invalid={isValid}
        valid={meta.touched && !isValid}
      />
      {isValid && <FormInvalidFeedback feedbackMsg={feedbackMsg} />}
    </div>
  )
}
